var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"continer"},[_c('baidu-map',{attrs:{"id":"allmap","scroll-wheel-zoom":true},on:{"ready":_vm.mapReady}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }